const DEBUG_FLAG_KEY = 'debugMode1337';

function isEnabled(): boolean {
  try {
    return localStorage.getItem(DEBUG_FLAG_KEY) === 'true';
  } catch {
    return false;
  }
}

const noop = (): void => {};

export function installDevConsole(): void {
  const c = console as Console;

  const define = (name: keyof Console, method: keyof Console): void => {
    Object.defineProperty(c, name, {
      configurable: true,
      get: () => (isEnabled() ? (c[method] as Function).bind(c) : noop),
    });
  };

  define('devlog', 'log');
  define('devinfo', 'info');
  define('devtable', 'table');
  define('devwarn', 'warn');
  define('deverror', 'error');
  define('devtrace', 'trace');
}
